import * as React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@sravni/react-design-system';
import getConfig from 'next/config';
import { ErrorTextWrapper } from '../form/ui/input/errorTextWrapper';
import { CONSENT_TO_ADVERTISING, CONSENT_TO_PROCESSING_PERSONAL_DATA_URL, PAGE } from '../../constants';
import { useSelection } from '../../store/reducers/selection';

type Props = React.ComponentProps<typeof Checkbox> & {
    errorMessage?: React.ReactNode;
    invalid?: boolean;
};

const Text = styled.span`
    color: var(--black-100);
`;

export const AgreementLink = React.forwardRef<HTMLInputElement, Props>(({ errorMessage, invalid, ...props }, ref) => {
    const { page } = useSelection();
    const label = React.useMemo(() => {
        const consentUrl =
            page === PAGE.AVITO
                ? getConfig().publicRuntimeConfig.avitoConsentUrl
                : CONSENT_TO_PROCESSING_PERSONAL_DATA_URL;

        return (
            <Text>
                При входе вы даете{' '}
                <a href={consentUrl} target="_blank" rel="noopener noreferrer">
                    согласие на обработку данных
                </a>{' '}
                и{' '}
                <a href={CONSENT_TO_ADVERTISING} target="_blank" rel="noopener noreferrer">
                    рекламу
                </a>
            </Text>
        );
    }, [page]);

    return (
        <ErrorTextWrapper errorText={errorMessage}>
            <Checkbox ref={ref} name="agreements" {...props}>
                {label}
            </Checkbox>
        </ErrorTextWrapper>
    );
});

AgreementLink.displayName = 'AgreementLink';
